import {Injectable} from '@angular/core';
import {AuthService} from '../../../../firebase/src/lib/services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class PayedService {

    constructor(
        public auth: AuthService
    ) {
    }

    get isSubscribedForAi() {
        return this.auth.isLoggedIn && this.isSubscribed();
    }

    isPayed() {
        if (!this.auth.userState) {
            return false;
        }
        const {leftover, payment, verified, subscription} = this.auth.userState;
        return this.auth?.userState && (!!payment || verified && leftover || this.isSubscribed());
    }

    isSubscribed() {
        const {subscription} = this.auth.userState;
        return subscription && subscription?.activated;
    }
}
